var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.51,
    height: 19.81,
    viewBox: "0 0 16.51 19.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(-243.41 -172.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_503",
    "data-name": "Path 503",
    d: "M257.7,191.91H243.654c-.222-.1-.244-.284-.244-.5q0-8.75,0-17.5c0-.032,0-.065,0-.1.008-.277.126-.4.407-.4.451,0,.9,0,1.354,0h.219c0-.3.009-.578,0-.854a.445.445,0,0,1,.238-.464h9.442c.064.053.132.1.19.16q2.251,2.249,4.5,4.5a1.044,1.044,0,0,1,.159.374.348.348,0,0,1,0,.115V189.4c0,.456-.08.534-.544.534h-1.238c-.062,0-.124.006-.2.011,0,.511-.007,1.007,0,1.5A.453.453,0,0,1,257.7,191.91Zm1.546-14.526h-4.1c-.422,0-.505-.085-.505-.512v-4.1h-8.573v16.483h13.18C259.247,185.3,259.247,181.354,259.247,177.384ZM244.08,191.237h13.18v-1.3H245.927c-.451,0-.534-.082-.534-.526V174.094H244.08Q244.079,182.676,244.08,191.237Zm11.229-17.967v3.43h3.435Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_504",
    "data-name": "Path 504",
    d: "M504.577,785.481h3.81a1.279,1.279,0,0,1,.193.007.325.325,0,0,1,.008.643,1.088,1.088,0,0,1-.193.009h-7.64a1.065,1.065,0,0,1-.193-.009.324.324,0,0,1,.011-.642,1.472,1.472,0,0,1,.212-.007Z",
    transform: "translate(-250.931 -599.183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M504.62,614.3h3.752a1.889,1.889,0,0,1,.231.01.306.306,0,0,1,.29.307.31.31,0,0,1-.267.326,1.087,1.087,0,0,1-.211.017h-7.659c-.279,0-.435-.123-.437-.33s.153-.331.433-.331Q502.685,614.3,504.62,614.3Z",
    transform: "translate(-250.962 -431.968)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M504.75,699.956h3.791a1.328,1.328,0,0,1,.231.009.3.3,0,0,1,.271.3.294.294,0,0,1-.228.318.821.821,0,0,1-.228.027q-3.83,0-7.66,0a.848.848,0,0,1-.228-.027.293.293,0,0,1-.225-.32.3.3,0,0,1,.272-.3,1.516,1.516,0,0,1,.231-.009Z",
    transform: "translate(-251.113 -515.637)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M504.614,443.646h-3.791a1.854,1.854,0,0,1-.193,0,.324.324,0,0,1-.3-.3.32.32,0,0,1,.258-.337.826.826,0,0,1,.191-.017q3.839,0,7.679,0a.729.729,0,0,1,.228.03.3.3,0,0,1,.215.327.3.3,0,0,1-.264.292,1.074,1.074,0,0,1-.212.009Z",
    transform: "translate(-250.97 -264.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M504.579,529.225h-3.791c-.331,0-.493-.11-.49-.331s.166-.329.5-.329h7.582a1.013,1.013,0,0,1,.268.027.294.294,0,0,1,.228.318.3.3,0,0,1-.252.3,1.215,1.215,0,0,1-.25.015Z",
    transform: "translate(-250.942 -348.213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M415.748,300.575c.309,0,.618,0,.927,0,.275,0,.4.114.4.382q.006.937,0,1.873a.334.334,0,0,1-.381.379q-.937,0-1.874,0a.34.34,0,0,1-.382-.383q-.006-.937,0-1.873a.339.339,0,0,1,.385-.378C415.13,300.572,415.439,300.575,415.748,300.575Zm-.646,1.964h1.3v-1.293h-1.3Z",
    transform: "translate(-167.064 -125.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M415.309,443.665c-.109,0-.219.006-.328,0a.327.327,0,0,1-.321-.3.314.314,0,0,1,.279-.338,4.874,4.874,0,0,1,.751,0,.306.306,0,0,1,.28.335.322.322,0,0,1-.332.308c-.109.006-.219,0-.328,0Z",
    transform: "translate(-167.285 -264.638)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_511",
    "data-name": "Path 511",
    d: "M415.333,700.019c.116,0,.232-.007.348,0a.3.3,0,0,1,.3.294.279.279,0,0,1-.248.335,4.67,4.67,0,0,1-.806,0,.293.293,0,0,1-.25-.336.312.312,0,0,1,.307-.293C415.1,700.013,415.217,700.019,415.333,700.019Z",
    transform: "translate(-167.301 -515.696)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_512",
    "data-name": "Path 512",
    d: "M415.31,785.464c.109,0,.22-.007.328,0a.323.323,0,0,1,.313.328.316.316,0,0,1-.3.32,6.412,6.412,0,0,1-.714,0,.324.324,0,0,1-.3-.325.33.33,0,0,1,.3-.32c.122-.011.245,0,.367,0Z",
    transform: "translate(-167.265 -599.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_513",
    "data-name": "Path 513",
    d: "M415.337,529.592c-.122,0-.245.008-.367,0a.307.307,0,0,1-.294-.3.3.3,0,0,1,.266-.325,5.142,5.142,0,0,1,.788,0,.288.288,0,0,1,.254.331.3.3,0,0,1-.28.293,3.577,3.577,0,0,1-.366,0A0,0,0,0,1,415.337,529.592Z",
    transform: "translate(-167.3 -348.587)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_514",
    "data-name": "Path 514",
    d: "M415.5,615.2c-.135-.01-.272-.008-.4-.031a.29.29,0,0,1-.251-.318.284.284,0,0,1,.267-.3,6.258,6.258,0,0,1,.771,0,.281.281,0,0,1,.268.3.288.288,0,0,1-.247.32A3.656,3.656,0,0,1,415.5,615.2Z",
    transform: "translate(-167.465 -432.19)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.46feae87bd235673ecea82791537e59f.svg";
export { ForwardRef as ReactComponent };